'use strict';

// This file not used after redesign, but still here for future. It contains set products modal and buy all functionality

import { queryFirst, queryAll, outerHeight, isInViewport, removeClass, addClass, hasClass, scrollTo } from './domUtil';

const bodyEl = queryFirst('body');
const stickyNav = queryFirst('.custom-set-detail-sticky-nav');
const mql = window.matchMedia('(min-width: 768px)');
const activeNavClass = 'active';
let ticking = false;
const productSetModal = document.getElementById('productSetModal');
const addAllToCartButton = queryFirst('button.add-to-cart-global', productSetModal);
const { body } = document;

const handleStickyScroll = () => {
    ticking = false;
    // show sticky nav on scroll up and at shopByItemStart, hide onn scroll down
    const currentScrollPos = window.pageYOffset;
    const shopByItemStart = document.querySelector('.setItems-main').offsetTop;

    if (!stickyNav) return;
    stickyNav.style.bottom = (currentScrollPos > shopByItemStart ? 0 : -outerHeight(stickyNav)) + 'px';

    // set the stick nav link of product in viewport class to active
    if ($('.set-grid-view .scrollable-product-item').length === 0) {
        queryAll('.scrollable-product-item').forEach(el => {
            if (!isInViewport(el)) return;

            const btnList = queryAll('.custom-set-detail-sticky-nav .sticky-nav-link');
            removeClass(btnList, activeNavClass);
            const elementPid = el.id;
            const activeItem = btnList.find(btn => btn.dataset.pid === elementPid);

            addClass(activeItem, activeNavClass);
        });
    } else {
        queryAll('.set-list-view .scrollable-product-item').forEach(el => {
            if (!isInViewport(el)) return;

            const btnList = queryAll('.custom-set-detail-sticky-nav .sticky-nav-link');
            removeClass(btnList, activeNavClass);
            const elementPid = el.id;
            const activeItem = btnList.find(btn => btn.dataset.pid === elementPid);

            addClass(activeItem, activeNavClass);
        });

        queryAll('.set-grid-view .scrollable-product-item').forEach((el, index) => {
            if (!(isInViewport(el) && index % 2 != 0)) return;

            const btnList = queryAll('.custom-set-detail-sticky-nav .sticky-nav-link');
            removeClass(btnList, activeNavClass);
            const elementPid = el.id;
            const activeItem = btnList.find(btn => btn.dataset.pid === elementPid);

            addClass(activeItem, activeNavClass);
        });
    }
};

const requestTick = () => {
    if (!ticking) {
        requestAnimationFrame(handleStickyScroll);
    }
    ticking = true;
};

const windowTest = w => {
    if (w.matches) {
        window.addEventListener('scroll', requestTick);
    } else {
        window.removeEventListener('scroll', requestTick);
    }
};

windowTest(mql);

const handleStickyNavClick = e => {
    const { target } = e;
    const elementID = document.getElementById(target.dataset.pid);

    addClass(target, activeNavClass);

    const scrollToElement = elementID;
    const headerHeight = queryFirst('header.main-header').offsetHeight;
    const wishlistButton = queryFirst('.add-to-wish-list', scrollToElement);

    scrollTo($(elementID).offset().top - headerHeight);

    if (wishlistButton) {
        wishlistButton.focus({ preventScroll: true });
    }
};

/**
 * This method updates add all to tote button
 */
function updateAddAllToTote() {
    const productsAvailability = queryAll('.product-availability', productSetModal).filter(item => !hasClass(item.closest('.product-detail'), 'hidden-set'));
    const numberOfProducts = productsAvailability.length;

    // Check to enable add to tote button, if atleast one product exists
    let enable = true;
    if (!numberOfProducts) {
        enable = false;
    }

    const addAllToCartButtonLabelEl = queryFirst('.add-to-cart-global-label', productSetModal);

    if (addAllToCartButton) {
        // Update product count on 'Add all to cart' button
        addAllToCartButton.disabled = !enable;
        if (numberOfProducts && addAllToCartButtonLabelEl) {
            addAllToCartButton.innerText = `${addAllToCartButtonLabelEl.dataset.buttonLabel} (${numberOfProducts})`;
        } else {
            addAllToCartButton.innerText = addAllToCartButtonLabelEl.dataset.buttonLabel;
        }
    }
}

const handleRemoveBtnClick = e => {
    const { target } = e;
    addClass(target.closest('.product-detail'), 'hidden-set');
    removeClass(target.closest('.product-detail'), 'custom-set-product');
    const productSetModal = document.getElementById('productSetModal');
    const areAllProductsRemoved = queryAll('.product-detail', productSetModal).every(productDetail => hasClass(productDetail, 'hidden-set'));
    if (areAllProductsRemoved) {
        const addAllToCartButton = queryFirst('button.add-to-cart-global', productSetModal);
        const addAllToCartButtonLabelEl = queryFirst('.add-to-cart-global-label', productSetModal);

        if (addAllToCartButton && addAllToCartButtonLabelEl) {
            addAllToCartButton.innerText = addAllToCartButtonLabelEl.dataset.buttonLabel;
            addAllToCartButton.disabled = true;
        }
    } else {
        updateAddAllToTote();
    }
};

const handleCancelClick = () => {
    removeClass(queryAll('.product-detail'), 'hidden-set');
    queryFirst('#productSetModal .modal-content').scrollTop = 0;
    addClass(queryAll('.custom-set-items .product-detail'), 'custom-set-product');
    updateAddAllToTote();
};

$(document).ready(() => {
    mql.addListener(windowTest);

    queryAll('.sticky-nav-link').forEach(el => {
        el.addEventListener('click', handleStickyNavClick);
    });
    queryAll('.set-remove-btn').forEach(el => {
        el.addEventListener('click', handleRemoveBtnClick);
    });
    queryFirst('.custom-set-cancel').addEventListener('click', handleCancelClick);
    $('#productSetModal').on('shown.bs.modal', () => {
        updateAddAllToTote();
    });

    if (addAllToCartButton) {
        addAllToCartButton.addEventListener('click', () => {
            const unavailableProductEl = queryFirst('.custom-set-product .product-availability[data-ready-to-order="false"]', productSetModal);
            if (unavailableProductEl && unavailableProductEl.dataset.readyToOrder === 'false') {
                const parentEl = unavailableProductEl.closest('.custom-set-product');
                parentEl.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' });
            }
        });
    }

    queryAll('.color-attribute', productSetModal).forEach(el => {
        el.addEventListener('click', e => {
            const { target } = e;
            const displayValue = target.dataset.attrDisplayvalue;
            const parentEl = target.closest('.attribute');
            queryFirst('.btn-link span', parentEl).textContent = displayValue;
        });
    });

    if (stickyNav) {
        addClass(bodyEl, 'pdp-set-page');
    }

    const productSetItems = queryAll('.product-set-item.product-detail');

    if (productSetItems.length) {
        productSetItems.forEach(eachItem => {
            const swatchEl = queryFirst('button.color-attribute .swatch-circle.selected', eachItem);
            if (swatchEl) {
                const sizeElements = queryAll('.size-btn', eachItem);
                if (sizeElements.length === 1 && !hasClass(sizeElements[0], 'selected')) {
                    sizeElements[0].click();
                }
            }
        });
    }
});
